
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import { StateType } from "./processTrace";
import { getProcessList } from "../../../../api/production";
import Throttle from "@/utils/throttle";
import { ImagePreview } from "vant";
import PreviewVideo from "@/components/previewVideo/previewVideo.vue";
let throttle: Throttle;
const states = {
  processData: [],
  screenHeight: 0,
  id: "",
  page: 1,
  previewVideoUrl: "",
  showVideos: false,
};
export default defineComponent({
  components: {
    PreviewVideo,
  },
  props: ["dataId"],
  setup(prop, { emit }) {
    const stateData = reactive<StateType>(states);
    const { getProcessDatas } = useDatas(stateData, emit);
    onMounted(() => {
      stateData.id = prop.dataId;
      stateData.page = 1;
      stateData.processData = [];
      getProcessDatas();
      throttle = new Throttle(500, () => {
        stateData.page++;
        getProcessDatas();
      });
    });
    return {
      ...toRefs(stateData),
      ...useEvent(stateData),
    };
  },
});
const useDatas = (state: StateType, emit: any) => {
  const getProcessDatas = async () => {
    const result: any = await getProcessList({
      page: state.page,
      pageSize: 10,
      traceSourceId: state.id,
    });
    if (result.data.code == 0) {
      state.processData = state.processData.concat(result.data.data.records);
    }
  };

  return {
    getProcessDatas,
  };
};

const useEvent = (state: StateType) => {
  const onPreviewVideo = (item: any) => {
    state.previewVideoUrl = item.url;
    state.showVideos = true;
  };
  const getDuration = (v: string) => {
    if (!v) {
      return "00:00";
    }

    let h = Math.floor(parseInt(v) / 1000 / 60).toString();
    let m = Math.floor((parseInt(v) / 1000) % 60).toString();
    h = h.padStart(2, "0");
    m = m.padStart(2, "0");
    return h + ":" + m;
  };
  const onPreviewImg = (i: number, v: any) => {
    ImagePreview({
      images: v.map((item: any) => {
        return item.url;
      }),
      startPosition: i,
    });
  };
  const onBottom = () => {
    throttle.search(null);
  };
  return {
    onBottom,
    onPreviewImg,
    getDuration,
    onPreviewVideo,
  };
};
